import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import useLang from "Shared/hooks/useLanguage";

const ExtractionRacksScanningLogInnerSection = ({
  innerRow,
}: {
  innerRow: any;
  setOpen: any;
  loadGridData: any;
}) => {
  const { t } = useLang();

  return (
    <div className="py-2">
      <div className="table_bordered overflow-hidden">
        <TableContainer className="shadow-none">
          <Table
            aria-label="sticky table collapsible"
            className="table table-cutome-expend table-bordered table-sticky-header table-head-2-bg table-bg table-head-custom table-vertical-center border-0 mb-0"
          >
            <TableHead>
              <TableRow>
                <TableCell className="min-w-150px w-150px">
                  {t("Rack Name")}
                </TableCell>

                <TableCell className="min-w-150px w-150px">
                  {t("Rack ID")}
                </TableCell>

                <TableCell className="min-w-150px w-150px">
                  {t("Plate No.")}
                </TableCell>

                <TableCell className="min-w-150px w-150px">
                  {t("Accession No")}
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {innerRow?.map((row: any) => (
                <TableRow key={row.rackPlateId}>
                  <TableCell
                    id={`IDCreateExtractionExpandSystemRackName_${row.rackPlateId}`}
                  >
                    {row.rackName}
                  </TableCell>

                  <TableCell
                    id={`IDCreateExtractionExpandSystemRackID_${row.rackPlateId}`}
                  >
                    {row.rackID}
                  </TableCell>

                  <TableCell
                    id={`IDCreateExtractionExpandSystemPlateNo_${row.rackPlateId}`}
                  >
                    {row.plateNo}
                  </TableCell>

                  <TableCell
                    id={`IDCreateExtractionExpandSystemAccessionNo_${row.rackPlateId}`}
                  >
                    {row.accessionNo}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};

export default ExtractionRacksScanningLogInnerSection;
